<template>
    <div>
        <div class="overtimeManagement-title">
            <div>{{$t('MCM.extraContributionManagement.title')}}</div>
        </div>
        <template>
            <Tabs size="small" :animated="false">
                <TabPane :label="$t('MCM.extraContributionManagement.additionalContributionStatistics')">
                    <add-overtime-statistics></add-overtime-statistics>
                </TabPane>
                <TabPane :label="$t('MCM.extraContributionManagement.attachmentList')">
                    <add-attachment-list></add-attachment-list>
                </TabPane>
            </Tabs>
        </template>
    </div>
</template>

<script>
    import AddOvertimeStatistics from '../overtime_management/AddOvertimeStatistics'
    import AddAttachmentList from '../overtime_management/AddAttachmentList'

    export default {
        name: 'OvertimeManagement',
        components: {
            AddOvertimeStatistics,
            AddAttachmentList
        }
    }
</script>

<style scoped>
    .overtimeManagement-title
    {
        width: 100%;
        font-size: 13px;
        -webkit-box-sizing: border-box;
        box-sizing: border-box;
        padding: 15px 0px 8px 4px;
        font-weight: 600;
    }
</style>



// WEBPACK FOOTER //
// src/components/configuration/operation_kpi_configuration_management/overtime_management/OvertimeManagement.vue